<template>
    <div>
        <image-uploader v-model="ctn.items.image01" :key="current_key" :disabled="!enabled"></image-uploader>
        <image-uploader v-model="ctn.items.image02" :key="'k_' + current_key" :disabled="!enabled"></image-uploader>
        <image-uploader v-model="ctn.items.image03" :key="'z_' + current_key" :disabled="!enabled"></image-uploader>
    </div>
</template>

<script>
import ImageUploader from './../ImageUploader/ImageUploader';

export default {
    props: [ 'disabled' ],
    components: {
        ImageUploader
    },
    data: function() {
        return {
            ctn: {
                items: {
                    image01: '',
                    image02: '',
                    image03: ''
                }
            },
            current_key: 0,
            enabled: true
        }
    },
    created: function()
    {
        if( this.$props.disabled === true ) this.enabled = false;
        if(this.$attrs.value) {
            this.ctn.items = this.$attrs.value;
        }
        setTimeout(()=>{
            this.ctn.items.image01 += '.';
            this.ctn.items.image01 = this.ctn.items.image01.slice(0,-1);
        },200);
    },
    methods: {
        getModuleData(){
            return this.ctn.items;
        }
    }
}
</script>

